import flattenDeep from 'lodash-es/flatMapDeep';

/**
 *
 * @param route_item - VueRouterItem
 * @param $permission - UserPermission
 * @return {boolean}
 */
export function is_allow_route(route, $permission = {}) {
  const { matched = [] } = route;
  const permissions = matched
    .filter(item => {
      const { meta = {} } = item;
      return meta && meta.permissions;
    })
    .map(item => item.meta.permissions);

  const flatten_permissions = flattenDeep(permissions); 

  if (flatten_permissions.length) {
    return flatten_permissions.every(key => $permission[key] === true);
  }

  return true;
}
